module.exports = __webpack_public_path__ + "static/Xiao-c4008794c0e69ad4776ebadae87cc50d.jpg";